/** Shared TanStack Query options for company-admin list screens. */
export const ADMIN_QUERY = {
  staleTime: 120_000,
  gcTime: 10 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};
